export default __webpack_public_path__ + "static/inline-edit-textfield-dont-4bf7f2e18cc76f8db5c9f899380cc11c.png";